export interface Tokens {
    access: string;
    refresh: string;
}

export class TokenManager {
    static getToken() {
        return localStorage.getItem("token") || sessionStorage.getItem("token");
    }

    static getRefreshToken() {
        return localStorage.getItem("refreshToken");
    }

    // Note: No refresh token is stored in sessionStorage if remember is false
    static setToken(tokens: Tokens, remember = false) {
        if (remember) {
            localStorage.setItem("token", tokens.access);
            localStorage.setItem("refreshToken", tokens.refresh);
        } else {
            sessionStorage.setItem("token", tokens.access);
        }
    }

    static clearToken() {
        localStorage.removeItem("token");
        localStorage.removeItem("refreshToken");
        sessionStorage.removeItem("token");
    }
}
